<template>
    <v-container>
        <router-link :to="{ name: 'GroupDetails', query: { name: $route.query.name }}">
            <v-btn>Go back</v-btn>
        </router-link>
        <div class="headline mt-4">Add new experiment</div>

        <v-form>
            <div class="ma-6">
                <v-row>
                    <v-text-field v-model="experiment.title" label="Title"></v-text-field>
                </v-row>

                <v-row>
                    <v-text-field v-model="experiment.group" label="Group"></v-text-field>
                </v-row>

                <div v-for="(variant, counter) in experiment.variants" v-bind:key="counter">
                    <v-icon @click="removeVariant(counter)">mdi-close</v-icon>
                    <v-row>
                        <v-text-field label="Variant name" v-model="variant.variant"></v-text-field>
                    </v-row>
                </div>

                <v-row>
                    <v-btn @click="addVariant" color="primary">Add variant</v-btn>
                </v-row>
            </div>

            <v-row>
                <v-btn
                  class="mt-4 mr-4"
                  @click="submit"
                  color="success"
                >
                    submit
                </v-btn>
                <v-btn
                  class="mt-4"
                  @click="clear"
                  color="warning">
                    clear
                </v-btn>
            </v-row>
        </v-form>

        <v-container v-if="response.data.code === 201">
            <v-row class="headline mt-4">New experiment has been created</v-row>
            <code style="display: block">{{ response.data.data }}</code>
        </v-container>
    </v-container>
</template>

<script>
    import ExperimentsAPI from "@/services/api/ABTesting/Experiments";

    export default {
        name: "AddExperiment",
        data () {
            return {
                experiment: {
                    title: '',
                    group: '',
                    variants: [
                        {
                            variant: '',
                        }
                    ]
                },
                response: {
                    data: {}
                }
            }
        },
        methods: {
            addVariant() {
                this.experiment.variants.push({
                    variant: '',
                })
            },
            removeVariant(counter) {
                this.experiment.variants.splice(counter, 1)
            },
            submit() {
                ExperimentsAPI.newExperiment(this.experiment)
                    .then(response => {
                        this.response = response

                        this.clear()
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            clear() {
                this.experiment = {
                    title: '',
                    variants: [
                        {
                            variant: ''
                        }
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
